export default "__VITE_ASSET__C_zVey04__"